/* eslint-disable import/prefer-default-export */
import trackError from '@helpers/trackError'
import { analytics } from '@helpers/analytics'

type EventProps = Record<string, unknown>

function event(name: string, eventProps: EventProps = {}) {
  try {
    analytics(name, eventProps)
  } catch (e) {
    trackError(e as Error)
  }
}

export function returnsAnalytics(name: string, eventProps: EventProps = {}) {
  event(name, {
    context: 'React',
    ...eventProps
  })
}

export function returnsClickEvent(eventProps: EventProps = {}) {
  event('Click', {
    category: 'Returns',
    ...eventProps
  })
}
